import module from 'cliente/module.js'

const schema = {
  id_documento: 'number',
  size: 'number',
}

export class ClienteInformacionJuridicoDocumentosService {
  constructor ($http, $api) {
    this.$http = $http
    this.$api = $api
  }

  get (idCliente) {
    return this.$http.get('/kendu/clientes/cliente/informacion/juridico/documentos', {
      params: {
        idCliente: idCliente,
      },
      cache: 'ClienteDocumentos',
      schema,
    })
  }

  post (idCliente, data) {
    const formData = new FormData()
    formData.append('idDocumento', data.idDocumento)
    formData.append('documento', data.documento)

    return this.$http.post('/kendu/clientes/cliente/informacion/juridico/documentos', formData, {
      params: {
        idCliente: idCliente,
      },
      clearCache: 'ClienteDocumentos',
      schema,
    })
  }

  delete (idCliente, idDocumento, indice) {
    return this.$http.delete('/kendu/clientes/cliente/informacion/juridico/documentos/documento', {
      params: {
        idCliente: idCliente,
        idDocumento: idDocumento,
        indice: indice,
      },
      clearCache: 'ClienteDocumentos',
    })
  }

  link (idCliente, idDocumento, indice) {
    return this.$api.link('/kendu/clientes/cliente/informacion/juridico/documentos/documento', {
      idCliente: idCliente,
      idDocumento: idDocumento,
      indice: indice,
    })
  }
}

module.service('ClienteInformacionJuridicoDocumentos', ClienteInformacionJuridicoDocumentosService)



// WEBPACK FOOTER //
// ./src/cliente/services/Informacion/Juridico/Documentos.js